// extracted by mini-css-extract-plugin
export default {"bottomLinks":"bottomLinks_tY0vk"};